// EstimateItem Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import DateUtil from '../../../lib/dateutil.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import PriceText from '../../../common/common/price_text/price_text.jsx'
import Avatar from '../../../common/common/avatar/avatar.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import Util from '../../../lib/util.jsx'
import app from '../../../app.jsx'

class EstimateItem extends Component {
  static get propTypes () {
    return {
      estimate: PropTypes.object,
      onSetting: PropTypes.func,
      onView: PropTypes.func,
      onDownload: PropTypes.func,
      downloadUrl: PropTypes.string,
      showProjectNumber: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      estimate: null,
      onSetting: null,
      onView: null,
      onDownload: null,
      downloadUrl: '',
      showProjectNumber: false
    }
  }

  render () {
    const { estimate, showProjectNumber } = this.props
    const date = new Date(estimate.createdOn)
    const typeClass = estimate.status.toLowerCase()
    const _className = classnames(
      'estimate-item',
      {},
      `estimate-item_${typeClass}`
    )

    return (
      <div className={_className}>
        <div className='content' onClick={this._onView.bind(this)}>
          {date && (
            <div className='coldate'>
              <div className='month'>{DateUtil.getDisplayMonth(date)}</div>
              <div className='day'>{DateUtil.getDisplayDay(date)}</div>
              <div className='year'>{DateUtil.getDisplayYear(date)}</div>
            </div>
          )}
          <div className='colsplit' />
          <div className='colinner'>
            <h4 className='title'>
              {estimate && estimate.contact && estimate.contact.company
                ? estimate.contact.company
                : ''}
            </h4>
            <div className='info'>
              {this._renderPurchaseOrder()}
              <span className='split' />
              <span
                className='project'
                onClick={this._onClickProject.bind(this, estimate.projectId)}
              >
                {estimate.project
                  ? (showProjectNumber
                    ? `${estimate.project.projectNumber || '-'} / `
                    : '') + `${estimate.project.title}`
                  : '-'}
              </span>
              <div className='split' />
              <div className='status'>
                <IntlMessage
                  ident={Util.getTranslatedStatus(estimate.status)}
                />
              </div>
            </div>
          </div>
          <div className='colavatar'>
            {estimate && estimate.contact && estimate.contact.imageUrl ? (
              <Avatar imageUrl={estimate.contact.imageUrl} />
            ) : null}
          </div>
          <div className='colsplit' />
          <div className='coltotal'>
            <div className='amount'>
              <h4 className='value'>
                <PriceText value={estimate.totalExcl} />
              </h4>
            </div>
            {this._renderInvoicedAmount()}
          </div>
        </div>
        <IconButton
          title='estimate.form.titleSettings'
          icon='common-action-setting'
          size='small'
          onClick={this._onSetting.bind(this)}
        />
      </div>
    )
  }

  // Private Functions

  _onClickProject (projectId, ev) {
    ev.preventDefault()
    ev.stopPropagation()

    app.changePage('projectview-budget', projectId)
  }

  _renderPurchaseOrder () {
    const estimate = this.props.estimate

    let estimateDate = ''
    if (estimate && estimate.reviewedOn) {
      estimateDate = ` / ${DateUtil.getDisplayDate(estimate.reviewedOn)}`
    }

    return (
      <div className='polink'>
        <IconButton
          title='estimate.form.titleDownload'
          tooltipPosition='top'
          icon='list-attachment'
          className='estimate'
          tooltip='estimate.form.tipAttachment'
          target='_blank'
          onClick={this._onDownload.bind(this)}
          href={encodeURI(`${this.props.downloadUrl}`)}
        />
        <div className='name'>
          {estimate.estimateNumber}
          {estimateDate}
        </div>
      </div>
    )
  }

  _renderInvoicedAmount () {
    const estimate = this.props.estimate

    if (estimate.invoiced) {
      return (
        <div className='invoice'>
          <span className='label'>
            <IntlMessage ident='estimate.form.invoicedText' />
          </span>
          <div className='cost'>
            <span>
              <PriceText value={estimate.invoicedAmount} />
            </span>
          </div>
        </div>
      )
    }

    return ''
  }

  _onSetting (event) {
    event.preventDefault()

    if (this.props.onSetting) {
      this.props.onSetting(this.props.estimate)
    }
  }

  _onView (event) {
    event.preventDefault()

    if (this.props.onView) {
      this.props.onView(this.props.estimate)
    }
  }

  _onDownload (event) {
    event.stopPropagation()
  }
}

export default EstimateItem
